import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import Axios from "./../../../../utils/api/axiosConf";
import { url } from "../../../../utils/api/api";
import { RedNotif, GreenNotif } from "../../../../utils/utils";
import BUTTON from "./../../../../components/buttons/button";
import TEXTROW from "../../../../components/textRow";
import LOADING from "../../../../components/loading/loading";
import INPUT from "./../../../../components/input/input";
import UPLOAD from "./../../../../components/uoload/upload";
import { Uploder } from "../../../../utils/utils";
import noPhoto from './../../../../assets/images/noPhoto.jpeg'


export default function Clubs(props) {

    const userId = props.userId
    const [loading, setLoading] = useState({ 1: false, 2: false, 3: false, 4: false });
    const [sportClub, setSportClub] = useState([]);
    const [newClub, setNewClub] = useState(null);
    const [image, setImage] = useState({ id: null, title: null });
    const [updater, setUpdater] = useState(1);


    useEffect(() => {
        setLoading({ ...loading, 1: true })
        Axios.get(`${url}users/sport-clubs-coch/${userId}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setSportClub(response.data.sportClubs)
                    setLoading({ ...loading, 1: false })
                    setImage({ id: null, title: null })
                }
                else {
                    RedNotif(response.message)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });
    }, [updater])



    const upload = async (e) => {
        var res = await Uploder(e, "profile")
        if (res.status == 200 || res.status == 201) {
            setLoading({ ...loading, 2: false })
            setImage({ "id": res.data._id, "link": `${url}${res.data.path}` })
        }
    }




    const submitClub = () => {
        if (newClub != null && newClub != "") {
            setLoading({ ...loading, 3: true })
            var x = { "sportClubs": [] };
            for (const iterator of sportClub) {
                x.sportClubs.push(
                    {
                        "title": iterator.title,
                        "image": iterator.image != null && iterator.image != undefined ?
                            iterator.image._id != null && iterator.image._id != null ? iterator.image._id
                                : "" : ""
                    }
                )
            }
            x.sportClubs.push(
                {
                    "title": newClub,
                    "image": image.id != null ? image.id : ""
                }
            )

            Axios.patch(`${url}users/edit-sport-clubs-coch/${userId}`, x)
                .then((response) => {
                    if (response.status === 200 || response.status === 201) {
                        setLoading({ ...loading, 3: false })
                        GreenNotif(response.message)
                        setUpdater(updater + 1)
                    }
                    else {
                        RedNotif(response.message)
                        setLoading({ ...loading, 3: false })
                    }
                })
                .catch((error) => {
                    RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
                    setLoading({ ...loading, 3: false })

                });
        } else {
            RedNotif("نام باشگاه الزامی است")
        }

    }

    const deleteClub = (item) => {

        var x = { "sportClubs": [] };
        sportClub.filter(function (obj) {
            if (obj.title !== item.title) {
                x.sportClubs.push(
                    {
                        "title": obj.title,
                        "image": obj.image._id != null ? obj.image._id : ""
                    }
                )
            }
        });

        Axios.patch(`${url}users/edit-sport-clubs-coch/${userId}`, x)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setLoading({ ...loading, 4: false })
                    GreenNotif(response.message)
                    setUpdater(updater + 1)
                }
                else {
                    RedNotif(response.message)
                    setLoading({ ...loading, 4: false })
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
                setLoading({ ...loading, 4: false })

            });
    }


    switch (loading[1]) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                <Row gutter={20}>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                        <p> نام باشگاه:  *</p>
                        <br />
                        <INPUT i={(e) => setNewClub(e)} />
                        <br />
                        <p>تصویر باشگاه :</p>
                        <br />
                        <div style={{ width: "250px", height: "150px" }}>
                            <UPLOAD
                                accept={".png,.jepg,.jpg"}
                                click={(e) => {
                                    setLoading({ ...loading, 2: true })
                                    upload(e)
                                }} loading={loading[2]} defultImage={image.link} />
                        </div>
                        <br />

                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Row style={{ width: '100%' }} gutter={16}>
                            {
                                sportClub.map((itm, idx) =>
                                    <Col key={idx} xxl={8} xl={8} lg={8} md={8} sm={8} xs={24} style={{ display: 'flex', justifyContent: "center", flexDirection: 'column', alignItems: 'center' }}>
                                        <p>{itm.title}</p>
                                        <br />
                                        <img style={{ width: "100%", height: "100px" }} src={itm.image != undefined && itm.image != null ? `${url}${itm.image.path}` : noPhoto} />
                                        <BUTTON
                                            text={"حذف باشگاه"}
                                            event={(e) => { deleteClub(itm) }}
                                            loading={loading[4]}
                                        />

                                    </Col>
                                )
                            }
                        </Row>
                    </Col>
                </Row>
                <Row style={{ marginTop: '64px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON
                            text={"ثبت باشگاه جدید"}
                            event={(e) => submitClub()}
                            loading={loading[3]}
                            type={"submit"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => props.pager(3)} text="رد کردن" type={"cancel"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>
            </>
        )
    }
}